module.exports = __webpack_public_path__ + "img/bank.25cfafd0.png";